export default [
	// 项目详情
	{
		path: 'detailsProject',
		name: 'detailsProject',
		component: () => import('@/views/crmManage/projectMange/projectList/detailsProject.vue'),
	},
]
